import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import plTranslation from './pl/translation.json';
import enTranslation from './en/translation.json';

// Initialize i18next with language detector
i18next
  .use(LanguageDetector)
  .init({
    debug: false, // Set to true for development debugging
    fallbackLng: 'pl', // Default language if detection fails
    supportedLngs: ['pl', 'en'],

    // Language detection configuration
    detection: {
      order: ['localStorage', 'navigator'], // Check localStorage first, then browser language
      caches: ['localStorage'], // Save user preference to localStorage
      lookupLocalStorage: 'i18nextLng',
    },

    // Resources (translations)
    resources: {
      pl: {
        translation: plTranslation
      },
      en: {
        translation: enTranslation
      }
    },

    // Interpolation settings
    interpolation: {
      escapeValue: false // React/Lit already escapes values
    },

    // Return empty string for missing keys instead of showing key
    returnEmptyString: false,
    returnNull: false,
  });

// Update document lang attribute when language changes
i18next.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);

  // Optional: Announce language change to screen readers
  const announcement = document.getElementById('lang-announcement');
  if (announcement) {
    announcement.textContent = lng === 'pl'
      ? 'Język zmieniony na polski'
      : 'Language changed to English';
  }
});

// Set initial lang attribute
document.documentElement.setAttribute('lang', i18next.language);

export default i18next;
